export default __webpack_public_path__ + "static/media/invalid-name.13f4010f.svg";